export interface Acceso {
  codigo_modulo: string;
  id_rol: number;
}

export interface PerfilResponse {
  perfil: ShowPerfil[];
}

export interface ShowPerfil {
  id_usuario: number;
  nombre: string;
  apellidos: string;
  email: string;
  departamento: string;
  sub_departamento?: string | null;
  img: string;
  activo: boolean;
  roles: PerfilRol[];
  modulos: PerfilModulo[];
}

export interface actualizarperfil {
  nombre: string;
  apellidos: string;
  email: string;
  departamento: string;
}

export interface cambiarpass {
  claveActual: string;
  nuevaClave: string;
  repetirClave: string;
}

export interface PerfilRol {
  rol: string;
}

export interface PerfilModulo {
  modulo: string;
}

export enum RolEnum {
  SUPERADMINISTRADOR = 1,
  ADMINISTRADOR = 2,
  USUARIO = 3,
  DIRECTOR = 4,
  OFPARTES = 5,
  OIRS = 6,
}

export enum TipoUsuarioEnum {
  ASISTENTETECNICO = 1,
}

export enum Cod_departamento {
  DIRECCIONDEASEO = 'ASEO',
  DIRECCIONDEOBRAS = 'OBRAS',
  DIRECCIONDIDECO = 'DIDECO',
  DIRECCIONDETRANSITO = 'TRANSIT',
  OFPARTES = 'OFPARTES',
  UNIDADINFORMATICA = 'SOPORTTI',
}

export enum ModuloEnum {
  OIRS = 'OIRS',
  SISDOC = 'SISDOC',
  FLOTA = 'FLOTA',
  PCI = 'PCI',
}

export enum PermisoGeneralEnum {
  CREAR_SOLICITUD = 'CREAR_SOLICITUD',
  CREAR_CIUDADANO = 'CREAR_CIUDADANO',
  VER_REPORTES = 'VER_REPORTES',
}

export interface RolesModulos {
  cod_unidad: Cod_departamento;
  roles: RolEnum[];
  modulos: ModuloEnum[];
  tipos_asistentes: TipoUsuarioEnum[];
  permisos_generales: PermisoGeneralEnum[];

  acciones_globales: string[];

  debe_cambiar_password?: boolean;
}

export interface LoginResponse {
  mensaje: string;
  usuario: {
    id_usuario: number;
    debe_cambiar_password: boolean;
    accesos: RolesModulos[];
  };
}

export interface CambiarPassResponse {
  mensaje: string;
  debe_cambiar_password: boolean;
}

export interface CheckRolesModulosResponse {
  CheckRolesModulos: RolesModulos[];
}
